export const BUDGET_CATEGORIES = [
  { key: 'staff_personnel', code: 'A', label: 'Staff and Other Personnel Costs' },
  { key: 'supplies_commodities_materials', code: 'B', label: 'Supplies, Commodities, Materials' },
  { key: 'equipment', code: 'C', label: 'Equipment' },
  { key: 'contractual_services', code: 'D', label: 'Contractual Services' },
  { key: 'travel', code: 'E', label: 'Travel' },
  { key: 'transfers_grants_counterparts', code: 'F', label: 'Transfers and Grants to Counterparts' },
  { key: 'general_operating_other', code: 'G', label: 'General Operating and Other Direct Costs' },
] as const;

export type BudgetCategoryKey = (typeof BUDGET_CATEGORIES)[number]['key'];
